import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { CashierReconciliationMaster } from "./CashierReconciliationMaster";

const CashierReconciliationManagementRoutes: FunctionComponent<RouteComponentProps> = ({
    match: { url }
  }) => (
    <Switch>
      <Route exact path={`${url}/`} render={() => <CashierReconciliationMaster />} />
      </Switch>
      );

export const CashierReconciliationManagement = withRouter(CashierReconciliationManagementRoutes);